var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.267 7.24H4.118A1.108 1.108 0 0 1 3 6.12C3 5.493 3.492 5 4.118 5h6.15c.625 0 1.117.493 1.117 1.12 0 .628-.514 1.12-1.118 1.12ZM10.983 7.218l5.254 4.437 1.879.336c1.677.291 2.884 1.77 2.884 3.473v1.524H4.073V9",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.163 11.946s4.516.672 4.516 3.697M12.26 8.738l-.76.762M13.76 10l-.76.762M16.238 11.655s-1.745.672-1.52 2.286M4.498 19l.805.672.805-.672.805.672.805-.672.805.672.805-.672.805.672.805-.672.805.672.805-.672.805.672.782-.672.805.672.805-.672.805.672.805-.672.805.672.805-.672.805.672.805-.672",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoot);
export default __webpack_public_path__ + "static/media/boot.11ecc86d.svg";
export { ForwardRef as ReactComponent };